import { formatCount, formatRelative } from '../../lib/format'
import type { Status } from './types'

export function JobsTable({ jobs }: { jobs: Status['jobs'] }) {
	const kinds = Object.keys(jobs).sort()
	if (kinds.length === 0) return <p className="muted">No jobs have run yet.</p>
	return (
		<div className="table-scroll">
			<table>
				<thead>
					<tr>
						<th>Job</th>
						<th className="num">Queued</th>
						<th className="num">Running</th>
						<th className="num">Failed</th>
						<th>Last success</th>
					</tr>
				</thead>
				<tbody>
					{kinds.map((k) => (
						<tr key={k}>
							<td>{k}</td>
							<td className="num">{formatCount(jobs[k].queued)}</td>
							<td className="num">{jobs[k].running}</td>
							<td className={`num ${jobs[k].failed ? 'error' : ''}`}>{jobs[k].failed}</td>
							<td className="muted small">{formatRelative(jobs[k].lastSuccessAt)}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
